module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic6.0be8a20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic6.png
// module id = 572
// module chunks = 1